import { useRef, useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

export default function ScrollableCategoryBar({ children, innerRef }) {
    const scrollRef = useRef(null);
    const [isAtStart, setIsAtStart] = useState(true);
    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const handleScroll = () => {
            setIsAtStart(el.scrollLeft <= 5);
        };

        const checkScrollable = () => {
            setIsScrollable(el.scrollWidth > el.clientWidth);
        };

        handleScroll(); // initial check
        checkScrollable(); // initial check

        el.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", checkScrollable);

        return () => {
            el.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", checkScrollable);
        };
    }, []);

    return (
        <div className="relative">
            {/* Gradient only right */}
            {isAtStart && isScrollable && <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-background to-transparent pointer-events-none z-10" />}

            {/* Right arrow shown only if scrollable and at start */}
            <AnimatePresence>
                {isAtStart && isScrollable && (
                    <motion.div
                        initial={{ opacity: 0, x: 10 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 10 }}
                        transition={{ duration: 0.3 }}
                        className="absolute -right-2 top-8 -translate-y-1/2 z-20 text-muted pointer-events-none"
                    >
                        <ChevronRight className="w-5 h-5 animate-pulse-slow" />
                    </motion.div>
                )}
            </AnimatePresence>

            {/* Scrollable container */}
            <div
                ref={(el) => {
                    scrollRef.current = el;
                    if (innerRef) innerRef.current = el;
                }}
                className="flex overflow-x-auto gap-4 pt-2 snap-x snap-mandatory scrollbar-hide no-scrollbar relative z-0 px-1"
            >
                {children}
            </div>
        </div>
    );
}